import type { ReactNode } from 'react';
import { errorMessage } from '@/lib/errors';
import { Button } from './Button';
import { Card } from './Card';
import { Spinner } from './Spinner';

export function LoadingState({ label = 'Loading' }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-3 py-12 text-text-muted">
      <Spinner label={label} />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  return (
    <Card role="alert" className="space-y-3 text-center">
      <p className="text-text">{errorMessage(error)}</p>
      {onRetry && (
        <Button variant="secondary" onClick={onRetry}>
          Try again
        </Button>
      )}
    </Card>
  );
}

export function EmptyState({
  title,
  body,
  action,
}: {
  title: string;
  body?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <Card className="space-y-2 py-8 text-center">
      <p className="font-semibold text-text">{title}</p>
      {body && <p className="text-sm text-text-muted">{body}</p>}
      {action && <div className="pt-2">{action}</div>}
    </Card>
  );
}

/** Small skeleton blocks keep layout stable while data loads on slow networks. */
export function Skeleton({ className = 'h-4 w-full' }: { className?: string }) {
  return <div aria-hidden className={`animate-pulse rounded-md bg-surface-muted ${className}`} />;
}
